/* src/modules/profile/cards/ChangePasswordCard/index.js */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { isEmpty, upperFirst } from 'lodash';

import { withStyles } from '@material-ui/core/styles';

import {
  Button,
  Paper,
  TextField,
} from '@material-ui/core';

import { ConfirmationPopup, PaperHeader } from '../../../../app/components';
import { loadTexts } from '../../../../config/texts';

import { changePassword } from '../../actions';
import { onError } from '../../../app_state/actions';

import styles from './styles';
const TEXT_KEY = 'profile';

class ChangePasswordCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      current: '',
      new: '',
      confirm: '',
      openConfirmation: false,
      texts: loadTexts(TEXT_KEY, props.locale)
    };

    this._onPressSubmit = this._onPressSubmit.bind(this);
    this._onChangeCurrent = this._onChangeCurrent.bind(this);
    this._onChangeNew = this._onChangeNew.bind(this);
    this._onChangeConfirm = this._onChangeConfirm.bind(this);
    this._onCloseConfirmation = this._onCloseConfirmation.bind(this);
  }

  async _onPressSubmit() {
    const { current, new: newPassword, confirm, texts: { password } } = this.state;
    if (newPassword !== confirm) {
      this.props.onError({ message: password.error });
      return;
    }
    await this.props.changePassword({ old: current, new: newPassword });
    this.setState({ current: '', new: '', confirm: '', openConfirmation: true });
  }

  _onChangeCurrent(event) {
    this.setState({ current: event.target.value });
  }

  _onChangeNew(event) {
    this.setState({ new: event.target.value });
  }

  _onChangeConfirm(event) {
    this.setState({ confirm: event.target.value });
  }

  _onCloseConfirmation() {
    this.setState({ openConfirmation: false });
  }

  renderTextField(classes, type) {
    const { texts: { password } } = this.state;

    let label = password.current;
    switch (type) {
      case 'current':
        label = password.current
        break;
      case 'new':
        label = password.new
        break;
      case 'confirm':
        label = password.confirm
        break;
      default:
        return
    };

    return (
      <TextField
        id={`${type}_password`}
        label={label}
        value={this.state[type]}
        onChange={this[`_onChange${upperFirst(type)}`]}
        margin="normal"
        fullWidth
        type="password"
      />
    );
  }

  render() {
    const { classes } = this.props;
    const { current, new: newPassword, confirm, openConfirmation, texts: { password } } = this.state;
    return (
      <Paper className={classes.paper}>
        <PaperHeader text={password.header} noPadding />
        {this.renderTextField(classes, 'current')}
        {this.renderTextField(classes, 'new')}
        {this.renderTextField(classes, 'confirm')}
        <div className={classes.buttonContainer}>
          <Button
            onClick={this._onPressSubmit}
            variant="contained"
            color="primary"
            disabled={isEmpty(current) || isEmpty(newPassword) || isEmpty(confirm)}
          >
            {password.button_text}
          </Button>
        </div>
        <ConfirmationPopup
          open={openConfirmation}
          title={password.pop_up.title}
          subtitle={password.pop_up.subtitle}
          affirmativeButtonText={password.pop_up.dismiss}
          onClose={this._onCloseConfirmation}
          onSubmit={this._onCloseConfirmation}
          noCancel
        />
      </Paper>
    );
  }
}

ChangePasswordCard.propTypes = {
  classes: PropTypes.object.isRequired,
  changePassword: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  locale: state.appState.locale,
});

const mapDispatchToProps = dispatch => ({
  changePassword: params => dispatch(changePassword(params)()),
  onError: params => dispatch(onError(params)),

});

export default compose(
  withStyles(styles, { name: 'ChangePasswordCard' }),
  connect(mapStateToProps, mapDispatchToProps)
)(ChangePasswordCard);



// WEBPACK FOOTER //
// ./src/modules/profile/cards/ChangePasswordCard/index.js